// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"36f61637","162":"c032875b","230":"89f0261f"}[chunkId] + ".chunk.js";
};